import { isInWechat } from '@utils/development';
import { lazyWeixinJsSdk } from '@utils/lazylib';

export function setupWechatShare(info, delay = 1000) {
  if (!isInWechat()) return;
  setTimeout(() => {
    lazyWeixinJsSdk()
      .then(wx => {
        if (!wx) {
          console.error('微信JSSDK加载失败');
          return;
        }
        wx.ready(function () {
          const data = {
            title: info.title || '宝宝树商城',
            desc: info.desc,
            link: info.link || location.href,
            imgUrl:
              info.imgUrl ||
              'https://img04.meituncdn.com/group1/M00/16/62/b914816e56304947a276255ee5e61695.png',
            success: function () {
              console.log('分享设置成功');
            },
            fail: function (res) {
              console.error('分享设置失败', res);
            }
          };
          wx.updateAppMessageShareData(data);
          wx.updateTimelineShareData(data);
        });
      })
      .catch(err => {
        console.error('加载微信JSSDK失败:', err);
      });
  }, delay);
}
